import LeftSide from "/components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import styles from "./index.module.scss";
import Icon from "/components/common/icon";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import { Api } from "~/api";
import {
  getCertificatePhotoUrl,
  getCertificateUrl,
} from "~/pagesSrrLogic/catalog/brandCert";

export default function CertificatesPage({
  scripts,
  host,
  isBaltex,
  certificates = [],
}) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title="Сертификаты"
      >
        <div className={styles.Certificates}>
          {certificates.map((certificate) => {
            const fileSrc = getCertificateUrl(certificate);
            const pictureSrc = getCertificatePhotoUrl(certificate);
            const fileSize = certificate?.data?.fileSize || "";

            return (
              <div
                key={certificate.id}
                itemScope=""
                itemType="http://schema.org/Article"
              >
                {pictureSrc && (
                  <a itemProp="url">
                    <img
                      itemProp="image"
                      src={pictureSrc}
                      alt={certificate.name}
                      title={certificate.name}
                    />
                  </a>
                )}
                <div className={styles.Info}>
                  <div itemProp="name" className={styles.Name}>
                    {certificate.name}
                  </div>
                  {fileSrc && (
                    <a
                      href={fileSrc}
                      target="_blank"
                      rel="noreferrer"
                      className={styles.Link}
                    >
                      <Icon fill="#1247a5" id="pdf" width={18} height={20} />
                      <div>
                        <div>Скачать</div>
                        {fileSize && <span>{fileSize}</span>}
                      </div>
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ query, req, resolvedUrl }) => {
    const reset = Boolean(query.reset);
    const certificates = await Api.databaseContent.getCertificates(
      Redis,
      reset,
    );

    store.dispatch(
      addBreadcrumb({ link: "/certificates/", name: "Сертификаты" }),
    );

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static, certificates },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/certificates/",
    );
  }),
);
